module.exports = __webpack_public_path__ + "img/bell-exclamation.566cacf3.svg";